module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "chinaArea"
    }
  }, [_c('div', {
    staticClass: "m-wrap-collect"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.province),
      expression: "province"
    }],
    staticClass: "oneInput",
    attrs: {
      "name": "province",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.province = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getProv],
      "focus": function($event) {
        _vm.focusHandler('pCode')
      },
      "blur": function($event) {
        _vm.blurHandler('pCode')
      }
    }
  }, _vm._l((_vm.provinces), function(prov) {
    return _c('option', {
      domProps: {
        "value": prov.id
      }
    }, [_vm._v("\n        " + _vm._s(prov.areaname) + "\n      ")])
  })), _vm._v("省\n    "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }],
    staticClass: "oneInput",
    attrs: {
      "name": "city",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getCity],
      "focus": function($event) {
        _vm.focusHandler('cCode')
      },
      "blur": function($event) {
        _vm.blurHandler('cCode')
      }
    }
  }, _vm._l((_vm.cities), function(ct) {
    return _c('option', {
      domProps: {
        "value": ct.id
      }
    }, [_vm._v("\n        " + _vm._s(ct.areaname) + "\n      ")])
  })), _vm._v("市\n    "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.area),
      expression: "area"
    }],
    staticClass: "oneInput",
    attrs: {
      "name": "area",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.area = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getArea],
      "focus": function($event) {
        _vm.focusHandler('aCode')
      },
      "blur": function($event) {
        _vm.blurHandler('aCode')
      }
    }
  }, _vm._l((_vm.areas), function(ae) {
    return _c('option', {
      domProps: {
        "value": ae.id
      }
    }, [_vm._v("\n        " + _vm._s(ae.areaname) + "\n      ")])
  })), _vm._v("区\n    "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "addressInput",
    attrs: {
      "name": "家庭住址"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "change": _vm.getAddr,
      "focus": function($event) {
        _vm.focusHandler('addr')
      },
      "blur": function($event) {
        _vm.blurHandler('addr')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "is-danger",
    style: (_vm.warning_style || "margin-left: 20px;")
  }, [_vm._v(_vm._s(_vm.errorInfo))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13ab990e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/chinaArea.vue
// module id = 951
// module chunks = 2